import { AdjacentType } from '@iotv/datamodel-core';
import { isViewObject, } from '../../../../types';
/** @deprecated - Only for use with ListerlizerAdapter, but would be best replaced with a Listerlizer */
export const isVariantA = (x) => !x.branchingQueryDefinition &&
    !x.targetObjectType &&
    [AdjacentType.CHILD, AdjacentType.PARENT, AdjacentType.SUBJECT].includes(x?.adjacentFilter?.adjacentType ?? 'never') &&
    x.viewObject &&
    isViewObject(x.viewObject);
/** @deprecated - Only for use with ListerlizerAdapter, but would be best replaced with a Listerlizer */
export const isVariantB = (x) => !isVariantC(x) &&
    !!x.branchingQueryDefinition &&
    !!x.resultFilter &&
    [AdjacentType.CHILD, AdjacentType.PARENT, AdjacentType.SUBJECT].includes(x?.adjacentFilter?.adjacentType ?? 'never') &&
    x.viewObject &&
    isViewObject(x.viewObject);
/** @deprecated - Only for use with ListerlizerAdapter, but would be best replaced with a Listerlizer */
export const isVariantC = (x) => typeof x.query === 'function';
